<div class="d-flex justify-content-end">
    <img class="m-3 c-pointer" src="assets/icons/close-blue.svg" (click)="activeModal.close('Cross click')">
</div>
<div class="evisa-container d-flex justify-content-center py-13 pt-6">
    <div class="w-100 w-sm-75 mx-3 mx-sm-0 border-blue-1 rounded-5">
        <p
            class="border-blue-1 border-end-0 border-start-0 border-top-0 ibm-medium heading-4 mb-0 p-3 text-center d-flex justify-content-center">
            <span class="heading-3 d-none d-md-block linear-gradient-text">{{"CREATE_VISA.AUTH_INSTRUCTION_TITLE" |
                translate}}</span>
            <span class="heading-4 d-md-none linear-gradient-text">{{"CREATE_VISA.AUTH_INSTRUCTION_TITLE" |
                translate}}</span>
        </p>

        <div class="px-6 py-6">
            <!-- <p class="fs-25 fw-400 mb-3 text-center">
                {{'CREATE_VISA.AUTH_INSTRUCTION'| translate }}
            </p> -->
            <p class="text-2 line-4 mb-3 text-blue-2">
                {{'CREATE_VISA.AUTH_INSTRUCTION'| translate }}
            </p>
            <div class="d-flex justify-content-center mt-5">
                <button class="px-6 py-2 btn-1" type="button" (click)="onClickVerify()">
                    {{ "CREATE_VISA.AUTH_RESPONSE_CHECK_BUTTON" | translate }}
                </button>
            </div>

            <div class="d-flex justify-content-center my-2">
                @if(resendCodeTime > 0 ){
                <p style="line-height: 1;" class="text-3 my-0 mt-2">
                    <span class="mx-2 text-blue-2">
                        {{'CREATE_VISA.AUTH_REQUEST_SEND_NOTE'| translate }}
                    </span>
                    <span class="mt-2 timer" style="color: rgb(255, 58, 68);">
                        {{ resendCodeTime | secondToMmss }}
                    </span>
                </p>
                }@else{
                <!-- <p style="line-height: 1;" class=" fs-20 fw-400 text-end click-here my-0 mt-2">
                    <span class="c-pointer" (click)="resendMobileAuth()">
                        {{ "CREATE_VISA.AUTH_RESEND_AUTH" | translate }}
                    </span>
                </p> -->
                <button class="px-6 py-2 btn-secondary mt-3" (click)="resendMobileAuth()" type="button">
                    {{'CREATE_VISA.AUTH_RESEND_AUTH' | translate}}</button>
                }
            </div>
        </div>
    </div>
</div>